<script lang="ts">
    import { tweened } from 'svelte/motion';
    import { cubicOut } from 'svelte/easing';
    import { beforeUpdate } from 'svelte';
    export let value: number;
    export let total: number;
    const progress = tweened(0, {
		    duration: 500,
		    easing: cubicOut
        });
    beforeUpdate(() => {
        progress.set(value);
    });
</script>

<style>
    .progress-container {
        width: 100%;
        background-color: rgba(0,0,0,.5);
        /* border: 1px solid white; */
        border-radius: 2px;
        height: 5px;
    }
    .progress {
        border-radius: 2px;
        background-color: var(--codecapi-green);
        height: 100%;
    }
    span.progress-text {
        color: rgba(0,0,0, .5);
        font-size: .8em;
    }
</style>
<div class="progress-container">
    <div class="progress" style={`width: ${1 + 100 *$progress/total}%`} />
</div>
<span class="progress-text">{ value + 1 } van { total }</span>
